import { render, staticRenderFns } from "./ListProduct.vue?vue&type=template&id=4c33ff24&scoped=true&"
import script from "./ListProduct.vue?vue&type=script&lang=js&"
export * from "./ListProduct.vue?vue&type=script&lang=js&"
import style0 from "./ListProduct.vue?vue&type=style&index=0&id=4c33ff24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c33ff24",
  null
  
)

export default component.exports